/* == SEA-FSM — fullscreen Clothing menu ==
 LIVE (ungated) .
 Trigger is bound to the header block id #item_nav_clothing, not to link text.
 == */
(function () {
  'use strict';

  var MIN_W = 1025;
  var OPEN_DELAY = 90;

  function init() {
    /* LIVE - the preview gate has been removed.
 The class stays: the CSS uses it to hold the header above the veil at all times,
 so the header does not drop back to grey mid-close. */
    document.documentElement.classList.add('sea-fsm-on');

    if (window.innerWidth < MIN_W) return;

    var menu = document.querySelector('[data-sea-fsm]');
    if (!menu || menu.dataset.seaFsmReady === '1') return;
    menu.dataset.seaFsmReady = '1';

    var li = document.getElementById('item_nav_clothing');
    var trigger = li ? li.querySelector('a') : null;
    if (!trigger) return;

    var header = document.querySelector('.t4s-section-header');
    var others = header
      ? Array.prototype.slice.call(header.querySelectorAll('.t4s-menu-item')).filter(function (el) { return el !== li; })
      : [];

    var timer = null;
    var locked = false;

    function open(lock) {
      window.clearTimeout(timer);
      locked = !!lock;
      menu.dataset.open = 'true';
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sea-fsm-open');
    }

    function close() {
      window.clearTimeout(timer);
      locked = false;
      menu.dataset.open = 'false';
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sea-fsm-open');
    }

    function isOpen() { return menu.dataset.open === 'true'; }

    trigger.addEventListener('mouseenter', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { open(false); }, OPEN_DELAY);
    });
    trigger.addEventListener('mouseleave', function () { window.clearTimeout(timer); });

    trigger.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (isOpen() && locked) { close(); } else { open(true); }
    });

    /* Any other top-level item closes it — the header stays usable. */
    others.forEach(function (el) {
      el.addEventListener('mouseenter', function () { if (isOpen()) close(); });
    });

    menu.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-sea-fsm-close]')) close();
    });

    document.addEventListener('keydown', function (ev) {
      if (isOpen() && ev.key === 'Escape') close();
    });

    /* No scroll lock. Scrolling closes instead — no scrollbar shift, no trap. */
    window.addEventListener('wheel', function () { if (isOpen()) close(); }, { passive: true });
    window.addEventListener('touchmove', function () { if (isOpen()) close(); }, { passive: true });

    window.addEventListener('resize', function () {
      if (window.innerWidth < MIN_W && isOpen()) close();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
/* == end SEA-FSM == */
